import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator(
  'limiting_factors',
  '/plans/limiting_factors',
  'limiting_factors'
)

const reducer = generator.generate()

export default reducer

